// Firebase initialization for web-app
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { FIREBASE_CONFIG } from '../../firebase-config.js';

// Initialize Firebase
const app = initializeApp(FIREBASE_CONFIG);

// Initialize Firestore
export const db = getFirestore(app);

// Export app instance if needed elsewhere
export default app;

